var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSheWomoNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1448,
    height: 328,
    viewBox: "0 0 1448 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M577.712 252.598H602.537V227.585H577.712V252.598Z",
    fill: "#922222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M552.886 277.612H577.712V252.598H552.886V277.612Z",
    fill: "#B22222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M577.712 302.471H602.537V277.457H577.712V302.471Z",
    fill: "#B22222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M577.712 327.485H602.537V302.471H577.712V327.485Z",
    fill: "#B22222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M602.524 277.612H627.35V252.598H602.524V277.612Z",
    fill: "#C32222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M602.524 327.485H627.35V302.471H602.524V327.485Z",
    fill: "#B22222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M652.383 327.485H677.208V302.471H652.383V327.485Z",
    fill: "#B22222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M652.383 227.584H677.208V202.571H652.383V227.584Z",
    fill: "#B22222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M652.512 25.8813L677.338 25.8813V0.867496L652.512 0.867496V25.8813Z",
    fill: "#B22222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M602.887 127.943V102.93H627.7V127.943",
    fill: "#B22222"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M652.383 177.984H677.208V152.97H652.383V177.984Z",
    fill: "#922222"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M627.35 302.471H652.176V277.457H627.35V302.471Z",
    fill: "#A50021"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M627.35 52.7336H652.176V27.7198L627.35 27.7198V52.7336Z",
    fill: "#A50021"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M702.5 25.0267L727.326 25.0267V0.0128822L702.5 0.0128822V25.0267Z",
    fill: "#B22222"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M677.338 51.8792H702.164V26.8653L677.338 26.8653V51.8792Z",
    fill: "#A50021"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M680.239 103.81H705.065V78.7962H680.239V103.81Z",
    fill: "#A50021"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M680.239 153.889H705.065V128.876H680.239V153.889Z",
    fill: "#A50021"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M680.239 203.956H705.065V178.942H680.239V203.956Z",
    fill: "#A50021"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M680.239 254.036H705.065V229.022H680.239V254.036Z",
    fill: "#A50021"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M705.401 277.263H730.227V252.249H705.401V277.263Z",
    fill: "#B22222"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M730.577 304.102H755.402V279.088H730.577V304.102Z",
    fill: "#B22222"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M780.383 302.471H805.209V277.457H780.383V302.471Z",
    fill: "#B22222"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M680.239 304.102H705.065V279.088H680.239V304.102Z",
    fill: "#A50021"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M730.227 253.531H755.053V228.517H730.227V253.531Z",
    fill: "#A50021"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M755.571 174.799H780.396V149.785H755.571V174.799Z",
    fill: "#B22222"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M730.395 201.651H755.221V176.638H730.395V201.651Z",
    fill: "#A50021"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M755.739 76.0385H780.565V51.0246H755.739V76.0385Z",
    fill: "#B22222"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M730.577 102.891H755.402V77.8769H730.577V102.891Z",
    fill: "#A50021"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M780.383 251.317H805.209V226.303H780.383V251.317Z",
    fill: "#B22222"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M830.035 279.101H854.86V254.087H830.035V279.101Z",
    fill: "#B22222"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M577.712 177.557H602.537V152.543H577.712V177.557Z",
    fill: "#B22222"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M627.35 152.53H602.537V177.557H627.35V152.53Z",
    fill: "#862222"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M552.886 327.485H577.712V302.471H552.886V327.485Z",
    fill: "#922222"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M503.248 327.485H528.073V302.471H503.248V327.485Z",
    fill: "#B22222"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M528.06 302.471H552.886V277.457H528.06V302.471Z",
    fill: "#B22222"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M478.422 302.471H503.248V277.457H478.422V302.471Z",
    fill: "#B22222"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M453.609 302.471H478.435V277.457H453.609V302.471Z",
    fill: "#922222"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M453.609 327.485H478.435V302.471H453.609V327.485Z",
    fill: "#B22222"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M428.783 302.471H453.609V277.457H428.783V302.471Z",
    fill: "#B22222"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M528.06 252.598H552.886V227.585H528.06V252.598Z",
    fill: "#B22222"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M552.886 227.584H577.712V202.571H552.886V227.584Z",
    fill: "#922222"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M577.712 202.998H602.537V177.984H577.712V202.998Z",
    fill: "#C32222"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M627.7 152.621H652.525V127.607H627.7V152.621Z",
    fill: "#C32222"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M552.886 177.557H577.712V152.543H552.886V177.557Z",
    fill: "#B22222"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M577.712 177.557H602.537V152.543H577.712V177.557Z",
    fill: "#9A2222"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M577.712 152.97H602.537V127.956H577.712V152.97Z",
    fill: "#B22222"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M552.886 127.956H577.712V102.943H552.886V127.956Z",
    fill: "#B22222"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M528.06 152.97H552.886V127.956H528.06V152.97Z",
    fill: "#922222"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M528.06 202.998H552.886V177.984H528.06V202.998Z",
    fill: "#B22222"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M503.248 227.584H528.073V202.571H503.248V227.584Z",
    fill: "#B22222"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M478.422 227.584H503.248V202.571H478.422V227.584Z",
    fill: "#C82222"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M478.422 252.598H503.248V227.585H478.422V252.598Z",
    fill: "#B22222"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M453.609 252.598H478.435V227.585H453.609V252.598Z",
    fill: "#9A2222"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M428.783 252.598H453.609V227.585H428.783V252.598Z",
    fill: "#B22222"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M428.783 227.584H453.609V202.571H428.783V227.584Z",
    fill: "#B22222"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M403.971 227.584H428.796V202.571H403.971V227.584Z",
    fill: "#B22222"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M503.248 202.998H528.073V177.984H503.248V202.998Z",
    fill: "#9A2222"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M528.06 177.984H552.886V152.97H528.06V177.984Z",
    fill: "#B22222"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M503.248 152.97H528.073V127.956H503.248V152.97Z",
    fill: "#B22222"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M503.248 127.956H528.073V102.943H503.248V127.956Z",
    fill: "#B22222"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M478.422 127.956H503.248V102.943H478.422V127.956Z",
    fill: "#C32222"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M478.771 103.007H503.597V77.9935H478.771V103.007Z",
    fill: "#B22222"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M453.959 103.007H478.785V77.9935H453.959V103.007Z",
    fill: "#C82222"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M429.133 103.007H453.959V77.9935H429.133V103.007Z",
    fill: "#B22222"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M354.669 103.007H379.495V77.9935H354.669V103.007Z",
    fill: "#B22222"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M255.392 103.007H280.218V77.9935H255.392V103.007Z",
    fill: "#8E2222"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M329.507 127.956H354.332V102.943H329.507V127.956Z",
    fill: "#B22222"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M304.681 127.956H329.507V102.943H304.681V127.956Z",
    fill: "#9A2222"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M279.868 127.956H304.694V102.943H279.868V127.956Z",
    fill: "#B22222"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M280.218 103.007H305.044V77.9935H280.218V103.007Z",
    fill: "#B22222"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M280.218 77.877H305.044V52.8631H280.218V77.877Z",
    fill: "#C82222"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M305.031 77.877H329.856V52.8631H305.031V77.877Z",
    fill: "#B22222"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M304.681 152.97H329.507V127.956H304.681V152.97Z",
    fill: "#B22222"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M255.043 177.557H279.868V152.543H255.043V177.557Z",
    fill: "#B22222"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M230.23 202.998H255.056V177.984H230.23V202.998Z",
    fill: "#B22222"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M230.23 152.97H255.056V127.956H230.23V152.97Z",
    fill: "#B22222"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M205.404 227.584H230.23V202.571H205.404V227.584Z",
    fill: "#B22222"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M180.592 202.998H205.417V177.984H180.592V202.998Z",
    fill: "#B22222"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M155.766 177.557H180.592V152.543H155.766V177.557Z",
    fill: "#B22222"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M205.404 177.557H230.23V152.543H205.404V177.557Z",
    fill: "#8E2222"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M205.404 127.956H230.23V102.943H205.404V127.956Z",
    fill: "#B22222"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M180.592 152.97H205.417V127.956H180.592V152.97Z",
    fill: "#B22222"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M329.856 103.007H354.682V77.9935H329.856V103.007Z",
    fill: "#B22222"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M329.856 77.877H354.682V52.8631H329.856V77.877Z",
    fill: "#922222"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M354.319 252.598H379.145V227.585H354.319V252.598Z",
    fill: "#B22222"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M255.043 252.598H279.868V227.585H255.043V252.598Z",
    fill: "#B22222"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M329.507 277.612H354.332V252.598H329.507V277.612Z",
    fill: "#B22222"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M304.681 277.612H329.507V252.598H304.681V277.612Z",
    fill: "#9A2222"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M279.868 277.612H304.694V252.598H279.868V277.612Z",
    fill: "#B22222"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M205.754 77.877H230.58V52.8631H205.754V77.877Z",
    fill: "#B22222"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M230.58 53.5105H255.405V28.4966L230.58 28.4966V53.5105Z",
    fill: "#B22222"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M180.941 53.5105H205.767V28.4966L180.941 28.4966V53.5105Z",
    fill: "#B22222"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M205.754 28.5355L230.58 28.5355V3.52167L205.754 3.52167V28.5355Z",
    fill: "#B22222"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M255.392 28.5355L280.218 28.5355V3.52167L255.392 3.52167V28.5355Z",
    fill: "#B22222"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M156.115 28.5355L180.941 28.5355V3.52167L156.115 3.52167V28.5355Z",
    fill: "#B22222"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3018 177.557H106.127V152.543H81.3018V177.557Z",
    fill: "#C82222"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M56.489 252.598H81.3147V227.585H56.489V252.598Z",
    fill: "#B22222"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8386 103.007H81.6643V77.9935H56.8386V103.007Z",
    fill: "#B22222"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24249e-05 152.97H24.8257L24.8257 127.956H3.24249e-05L3.24249e-05 152.97Z",
    fill: "#B22222"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M131.29 77.877H156.115V52.8631H131.29V77.877Z",
    fill: "#B22222"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M131.29 103.007H156.115V77.9935H131.29V103.007Z",
    fill: "#B22222"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M130.94 127.956H155.766V102.943H130.94V127.956Z",
    fill: "#B22222"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M156.115 103.007H180.941V77.9935H156.115V103.007Z",
    fill: "#B22222"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M106.477 103.007H131.303V77.9935H106.477V103.007Z",
    fill: "#B22222"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M130.94 227.584H155.766V202.571H130.94V227.584Z",
    fill: "#B22222"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M130.94 252.598H155.766V227.585H130.94V252.598Z",
    fill: "#9A2222"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M130.94 277.612H155.766V252.598H130.94V277.612Z",
    fill: "#B22222"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M155.766 252.598H180.592V227.585H155.766V252.598Z",
    fill: "#B22222"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M106.127 252.598H130.953V227.585H106.127V252.598Z",
    fill: "#B22222"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M205.404 277.612H230.23V252.598H205.404V277.612Z",
    fill: "#C32222"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M205.404 327.485H230.23V302.471H205.404V327.485Z",
    fill: "#B22222"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M279.868 252.598H304.694V227.585H279.868V252.598Z",
    fill: "#C32222"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M279.868 227.584H304.694V202.571H279.868V227.584Z",
    fill: "#B22222"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M304.681 227.584H329.507V202.571H304.681V227.584Z",
    fill: "#B22222"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M304.681 202.998H329.507V177.984H304.681V202.998Z",
    fill: "#B22222"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M329.507 252.598H354.332V227.585H329.507V252.598Z",
    fill: "#B22222"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M329.507 227.584H354.332V202.571H329.507V227.584Z",
    fill: "#B22222"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M428.783 127.956H453.609V102.943H428.783V127.956Z",
    fill: "#B22222"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M403.971 127.956H428.796V102.943H403.971V127.956Z",
    fill: "#B22222"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M403.971 152.97H428.796V127.956H403.971V152.97Z",
    fill: "#B22222"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M379.145 152.621H403.971V127.607H379.145V152.621Z",
    fill: "#B22222"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M379.145 177.557H403.971V152.543H379.145V177.557Z",
    fill: "#922222"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M354.319 177.557H379.145V152.543H354.319V177.557Z",
    fill: "#B22222"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M403.971 202.998H428.796V177.984H403.971V202.998Z",
    fill: "#B22222"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M379.145 202.648H403.971V177.634H379.145V202.648Z",
    fill: "#B22222"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M528.41 103.007H553.236V77.9935H528.41V103.007Z",
    fill: "#B22222"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M429.133 77.877H453.959V52.8631H429.133V77.877Z",
    fill: "#B22222"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M404.32 77.877H429.146V52.8631H404.32V77.877Z",
    fill: "#B22222"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M478.422 277.612H503.248V252.598H478.422V277.612Z",
    fill: "#C82222"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M428.783 277.612H453.609V252.598H428.783V277.612Z",
    fill: "#B22222"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M403.971 277.612H428.796V252.598H403.971V277.612Z",
    fill: "#922222"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M453.609 177.557H478.435V152.543H453.609V177.557Z",
    fill: "#B22222"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M602.524 227.584H627.35V202.571H602.524V227.584Z",
    fill: "#B22222"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M627.35 252.598H652.176V227.585H627.35V252.598Z",
    fill: "#B22222"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M655.413 277.612H680.239V252.598H655.413V277.612Z",
    fill: "#922222"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M627.35 202.998H652.176V177.984H627.35V202.998Z",
    fill: "#B22222"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M305.031 53.5105H329.856V28.4966L305.031 28.4966V53.5105Z",
    fill: "#B22222"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M304.681 302.471H329.507V277.457H304.681V302.471Z",
    fill: "#B22222"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M503.248 277.612H528.073V252.598H503.248V277.612Z",
    fill: "#B22222"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M503.597 77.877H528.423V52.8631H503.597V77.877Z",
    fill: "#B22222"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M478.771 77.877H503.597V52.8631H478.771V77.877Z",
    fill: "#8E2222"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M478.771 53.5105H503.597V28.4966L478.771 28.4966V53.5105Z",
    fill: "#B22222"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M453.959 53.5105H478.785V28.4966L453.959 28.4966V53.5105Z",
    fill: "#B22222"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M453.959 28.5355L478.785 28.5355V3.52167L453.959 3.52167V28.5355Z",
    fill: "#B22222"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M429.133 53.5105H453.959V28.4966L429.133 28.4966V53.5105Z",
    fill: "#B22222"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M578.048 103.007H602.874V77.9935H578.048V103.007Z",
    fill: "#C32222"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M553.236 77.877H578.061V52.8631H553.236V77.877Z",
    fill: "#B22222"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M528.41 53.5105H553.236V28.4966L528.41 28.4966V53.5105Z",
    fill: "#B22222"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M627.35 52.8501H602.874V53.5104H627.35V52.8501Z",
    fill: "#B22222"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M602.887 28.4966H602.771V53.5104H602.887V28.4966Z",
    fill: "#B22222"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M627.7 52.8501H602.874V77.8639H627.7V52.8501Z",
    fill: "#B22222"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M602.887 103.007H627.713V77.9935H602.887V103.007Z",
    fill: "#922222"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M652.525 78.0063H627.7V103.02H652.525V78.0063Z",
    fill: "#922222"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M652.383 127.956H677.208V102.943H652.383V127.956Z",
    fill: "#CB2222"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M653.16 79.1199H652.15V79.2752H653.16V79.1199Z",
    fill: "#B22222"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M578.048 53.5105H602.874V28.4966L578.048 28.4966V53.5105Z",
    fill: "#B22222"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M553.236 28.5355L578.061 28.5355V3.52167L553.236 3.52167V28.5355Z",
    fill: "#B22222"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M578.048 28.5355L602.874 28.5355V3.52167L578.048 3.52167V28.5355Z",
    fill: "#B22222"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M503.597 28.5355L528.423 28.5355V3.52167L503.597 3.52167V28.5355Z",
    fill: "#B22222"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M849.369 235.172C849.369 303.506 804.587 327.485 709.623 327.485C614.659 327.485 567.649 294.185 567.649 216.541H634.175C634.175 269.365 647.06 319.056 709.571 319.056C785.408 319.056 817.356 305.733 817.356 248.494C817.356 208.112 773.028 194.777 698.02 183.292C615.099 170.41 575.173 139.79 575.173 83.004C575.173 26.2179 631.494 0 694.51 0C782.339 0 833.363 35.9153 833.363 104.69H769.065C769.065 45.2243 758.42 8.41563 694.562 8.41563C649.34 8.41563 602.278 21.7382 602.278 64.7486C602.278 90.9018 624.035 110.426 698.965 120.641C829.84 138.379 849.357 184.509 849.357 235.094V235.146L849.369 235.172Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M953.593 8.44153V153.074H1097.3V8.44153H1159.42V319.004H1097.3V161.489H953.593V319.004H891.471V8.44153H953.593Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1447.71 8.44155V16.8572H1266.26V153.061H1407.79V161.477H1266.26V310.576H1447.71V318.991H1204.19V8.42859H1447.71V8.44155Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheWomoNew);
export default __webpack_public_path__ + "static/media/she_womo_new.b09d3f21859b5a3c434be987b67c0bb7.svg";
export { ForwardRef as ReactComponent };